import React from "react";
import { RenderOnlyFor, useGuideConfig } from "@ignitesales/neuro-application";
import BasicFooter from "../../../../../../../shared/js/core-components/BasicFooter.jsx";
import BasicHeader from "../../../../../../../shared/js/core-components/BasicHeader";
import ContactShareButtons from "../../../../../../../shared/js/core-components/ContactShareButtons";
import DialogueProductWrapper from "../../../../../../../shared/js/core-components/DialogueProductWrapper";
import { CollapsibleAnswersList } from "../../../../../../../shared/js";
import ReturnToSurveyButton from "../../../../../../../shared/js/core-components/ReturnToSurveyButton";
import {
    SummaryPageSubtitle,
    SummaryPageTitle,
} from "../../../../../../../shared/js/core-components/ProductPageMessages";
import ActionButtonContainer from "../../../../../../../shared/js/core-components/ActionButtonContainer";
import LayoutBlockContainer from "../../../../../../../shared/js/core-components/blocks/LayoutBlockContainer";
import useRecommendedProductActionTrigger from "../../../../../../../shared/js/hooks/useRecommendedProductActionTrigger.mjs";
import { useDialogueGuideSettings } from '../../../../../../../shared/js/hooks/useDialogueGuideSettings.mjs';

function SummaryPage({ componentClass, productsList }) {
    useRecommendedProductActionTrigger(productsList);
    const { showEditAnswers } = useDialogueGuideSettings();
    const { layouts = [] } = useGuideConfig();
    const pageName = `${componentClass}_page`;
    const hasLayoutBlock = (page, position) => layouts?.some((layout) =>
        layout.layoutType === "block" &&
        layout.block?.page === page &&
        layout.block?.position === position
    );

    return (
        <div className={componentClass} id={pageName}>
            <img
                src={"/classpath/assets/images/background-curve.png"}
                alt="background-curve"
                className={`${componentClass}__background`}
            />
            <div className="container">
                <div className={`${componentClass}__header`}>
                    <div className="header-text">
                        <SummaryPageTitle tagName="h1" />
                        <RenderOnlyFor forSummaryPage={true}>
                            {hasLayoutBlock("SummaryPage", "subtitle") ? (
                                <LayoutBlockContainer
                                    position="subtitle"
                                    page="SummaryPage"
                                />
                            ) : (
                                <SummaryPageSubtitle tagName="p" />
                            )}
                        </RenderOnlyFor>
                        <RenderOnlyFor forDetailsPage={true}>
                            {hasLayoutBlock("DetailsPage", "subtitle") ? (
                                <LayoutBlockContainer
                                    position="subtitle"
                                    page="DetailsPage"
                                />
                            ) : (
                                <SummaryPageSubtitle tagName="p" />
                            )}
                        </RenderOnlyFor>
                    </div>
                    <div className="header-buttons">
                        <RenderOnlyFor forSummaryPage={true}>
                            <ContactShareButtons useFullWidthButtons={true} />
                            <ActionButtonContainer
                                position="top"
                                page="SummaryPage"
                            ></ActionButtonContainer>
                        </RenderOnlyFor>
                        <RenderOnlyFor forDetailsPage={true}>
                            <ActionButtonContainer
                                position="top"
                                page="DetailsPage"
                            ></ActionButtonContainer>
                        </RenderOnlyFor>
                    </div>
                </div>

                <div className={`${componentClass}__products`}>
                    {productsList.map((p) => (
                        <DialogueProductWrapper key={p.id} product={p} />
                    ))}
                </div>

                <div className={`${componentClass}__actions`}>
                    <RenderOnlyFor forSummaryPage={true}>
                        <ActionButtonContainer
                            position="bottom"
                            page="SummaryPage"
                        ></ActionButtonContainer>
                    </RenderOnlyFor>
                    <RenderOnlyFor forDetailsPage={true}>
                        <ActionButtonContainer
                            position="bottom"
                            page="DetailsPage"
                        ></ActionButtonContainer>
                    </RenderOnlyFor>
                </div>

                <CollapsibleAnswersList
                    className={`${componentClass}__answers`}
                    shouldLinkToQuestion={showEditAnswers}
                />
                <ReturnToSurveyButton
                    className={`${componentClass}__navigation`}
                />
            </div>
            <BasicFooter />
        </div>
    );
}

export default SummaryPage;
